<div class="row">
    <div class="col-md-1">
        <app-company-audit-type-add [companyId]="companyId"
                                    (companyAuditTypeAdded)="onCompanyAuditTypeAdded($event)">
        </app-company-audit-type-add>
    </div>
</div>

<section class="panel">
    <header class="panel-heading">
        <h2 class="panel-title">Existing Audit Types</h2>
    </header>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let auditType of auditTypes;index as i">
                        <td>{{i+1}}</td>
                        <td>{{auditType.name}}</td>
                        <td class="actions">
                            <a (click)="selectedAuditTypeId=auditType.auditTypeId; confirmation.showMessage()" title="Delete Audit Type" class="mb-1 mt-1 mr-2"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteCompanyAuditType()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this audit type?'">
</app-confirmation-message>
